import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import { __decorate } from "tslib";
import { Vue, Options } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import UserCell from '@/components/platform/copySpeach/UserCell.vue';
import store from '@/store';
var SelectCategory = /*#__PURE__*/function (_Vue) {
  function SelectCategory() {
    var _this;
    _classCallCheck(this, SelectCategory);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, SelectCategory, [].concat(args));
    _defineProperty(_this, "name", void 0);
    _defineProperty(_this, "platform", void 0);
    _defineProperty(_this, "value", void 0);
    _defineProperty(_this, "defaultValue", void 0);
    _defineProperty(_this, "addEmptyValue", void 0);
    _defineProperty(_this, "placeholder", void 0);
    _defineProperty(_this, "realValue", null);
    return _this;
  }
  _inherits(SelectCategory, _Vue);
  return _createClass(SelectCategory, [{
    key: "mounted",
    value: function mounted() {
      this.setRealValue();
    }
  }, {
    key: "categories",
    get: function get() {
      var categories = store.getters.categories(this.platform);
      if (this.addEmptyValue && categories) {
        categories = Array.from(categories);
        categories.unshift(null);
      }
      return categories;
    }
  }, {
    key: "onChangeValue",
    value: function onChangeValue(selectedValue) {
      var _this2 = this;
      this.realValue = selectedValue;
      this.$emit('input', this.categories.find(function (cat) {
        return cat !== null && cat.id === _this2.realValue;
      }));
    }
  }, {
    key: "onChangePropValue",
    value: function onChangePropValue() {
      this.setRealValue();
    }
  }, {
    key: "onChangePropDefaultValue",
    value: function onChangePropDefaultValue() {
      this.setRealValue();
    }
  }, {
    key: "resetCategory",
    value: function resetCategory() {
      this.realValue = null;
      this.onChangeValue(this.realValue);
    }
  }, {
    key: "setRealValue",
    value: function setRealValue() {
      var _this$value, _this$defaultValue;
      this.realValue = ((_this$value = this.value) === null || _this$value === void 0 ? void 0 : _this$value.id) || ((_this$defaultValue = this.defaultValue) === null || _this$defaultValue === void 0 ? void 0 : _this$defaultValue.id);
    }
  }]);
}(Vue);
__decorate([Prop({
  default: 'category'
})], SelectCategory.prototype, "name", void 0);
__decorate([Prop({
  default: ''
})], SelectCategory.prototype, "platform", void 0);
__decorate([Prop({
  default: null
})], SelectCategory.prototype, "value", void 0);
__decorate([Prop({
  default: null
})], SelectCategory.prototype, "defaultValue", void 0);
__decorate([Prop({
  default: false
})], SelectCategory.prototype, "addEmptyValue", void 0);
__decorate([Prop({
  default: ''
})], SelectCategory.prototype, "placeholder", void 0);
__decorate([Watch('value')], SelectCategory.prototype, "onChangePropValue", null);
__decorate([Watch('defaultValue')], SelectCategory.prototype, "onChangePropDefaultValue", null);
__decorate([Watch('platform')], SelectCategory.prototype, "resetCategory", null);
SelectCategory = __decorate([Options({
  components: {
    UserCell: UserCell
  }
})], SelectCategory);
export default SelectCategory;